<template>
  <div>
    <v-text-field
      @change="$emit('numero', numeroModel)"
      @blur="geocode()"
      v-model="numeroModel"
      :label="$t('Numero')"
      name="numero"
      class="purple-input"
      type="number"
      hide-details
      dense
      flat
      filled
      solo
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "CampoNumeroBuscaGeoCode",

  props: {
    logradouro: { type: String, default: "" },
    bairro: { type: String, default: "" },
    cep: { type: String, default: "" },
    numero: { type: String, default: "" },
  },

  computed: {
    address() {
      if (this.logradouro && this.bairro && this.numeroModel && this.cep) {
        return (
          this.logradouro +
          ", " +
          this.numeroModel +
          ", " +
          this.bairro +
          " " +
          this.cep
        );
      }

      return "";
    },
    numeroModel: {
      get() {
        return this.numero;
      },
      set(value) {
        this.$emit("numero", value);
      },
    },
  },

  methods: {
    geocode() {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode(
        {
          address: this.address,
          region: "br",
          componentRestrictions: { country: "BR" },
        },
        (results, status) => {
          if (status == "OK") {
            console.log(results[0].geometry.location);
            this.$emit("latitude", results[0].geometry.location.latitude);
            this.$emit("longitude", results[0].geometry.location.longitude);
          } else {
            alert(
              "Geocode was not successful for the following reason: " + status
            );
          }
        }
      );
    },
  },
};
</script>

<style></style>
